import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Input,
  InputGroup,
  InputRightElement,
  Card,
  Flex,
  Heading,
  Text,
  Select,
  Spinner,
  Spacer,
  Td,
  Tr,
} from "@chakra-ui/react";
import { FiSearch } from "react-icons/fi";
import { get_otp_list } from "../../redux/OtpSlice";
import TableView from "../../components/TableView";
import GasCylinderLoader from "../../components/GasCylinderLoader";

const OtpCollection = () => {
  const dispatch = useDispatch();
  const { otp_list, loading, total_count } = useSelector((state) => state.otp);

  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    dispatch(get_otp_list({ page, limit: rowsPerPage, search }));
  }, [dispatch, search, page, rowsPerPage]);

  const initialValue = (page - 1) * rowsPerPage + 1;
  const totalPages = Math.ceil(total_count / rowsPerPage) || 1;

  return (
    <>
      {/* Header */}
      <Card
        bg="#fff"
        paddingInline={5}
        paddingBlock={2}
        display="flex"
        flexDirection={["column", "column", "row"]}
        alignItems={["stretch", "stretch", "center"]}
        gap={3}
        flexWrap="wrap"
      >
        <Heading fontSize={"xl"}>OTP Collection</Heading>
        <Spacer display={["none", "none", "block"]} />
        <Flex gap={3} align="center" direction={{ base: "column", sm: "row" }} w={{ base: "100%", md: "auto" }}>
          <InputGroup bg="#f4f5f7" borderRadius={5} w={{ base: "100%", sm: "auto" }} maxW="sm">
            <Input
              placeholder="Search by Mobile Number"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
              }}
            />
            <InputRightElement>
              <FiSearch />
            </InputRightElement>
          </InputGroup>
        </Flex>
      </Card>

      {/* Loader */}
      {loading && (
        <GasCylinderLoader
        size="md"
        loadingText="Loading OTP Collection..."
        />
      )}

      {/* TableView */}
      {!loading && otp_list.length > 0 && (
        <Card overflowX="auto" mt={4}>
          <TableView
            headData={["S. No.", "Mobile", "OTP", "Date & Time"]}
            body={otp_list.map((item, index) => (
              <Tr key={item.id}>
              <Td textAlign="center">{index + initialValue}</Td>
                <Td textAlign="center" fontWeight="medium">{item.mobile}</Td>
                <Td textAlign="center" fontWeight="bold">{item.otp}</Td>
                <Td textAlign="center">{item.datetime}</Td>
              </Tr>
            ))}
            initialValue={initialValue}
            page={page}
            rows={rowsPerPage}
            total_value={total_count}
            pagination
            onChange={(e) => {
              const newRows = parseInt(e.target.value);
              setPage(1);
              setRowsPerPage(newRows);
            }}
            onPrevious={() => setPage((prev) => Math.max(prev - 1, 1))}
            onNext={() => setPage((prev) => Math.min(prev + 1, totalPages))}
          />
        </Card>
      )}

      {/* No Records */}
      {!loading && otp_list.length === 0 && (
        <Card p={6} mt={6} textAlign="center">
          <Text color="gray.600" fontWeight="medium">
            No OTP records found.
          </Text>
        </Card>
      )}
    </>
  );
};

export default OtpCollection;